import React from "react";
import { cn } from "../../../../helpers/cn";

type ListingCoachAboutHeaderProps = React.ComponentProps<"div">;

export const ListingCoachAboutHeader = ({
  className,
  children,
  ...props
}: ListingCoachAboutHeaderProps) => {
  return (
    <div className={cn("space-y-[8px]", className)} {...props}>
      {children}
    </div>
  );
};
